import React, { useEffect, useState } from "react";
import Spinner from './spinner/spinner'
const LMS_API_URL = process.env.REACT_APP_LMS_API_URL
const LMS_ID = process.env.REACT_APP_LMS_ID;

const SampleModuleEngagement = () => {
    const [sessionHtml, setSessionHtml] = useState("");
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        fetch(LMS_API_URL + "engagement/get/getEngagementDetailsByModuleId/" + LMS_ID)
            .then((res) => {
                setLoading(false)
                return res.json()
            })
            .then((data) => {
                const html = data?.data?.EngagementDetails?.engagementText || "";
                setSessionHtml(html || []);
            })
            .catch((err) => { setLoading(false); setSessionHtml(''); console.error("Error fetching:", err) });
    }, []);

    return (
        loading ? <Spinner /> :
            <div className="container py-4" >
                {/* Header Section */}
                {sessionHtml ? <>
                    <div className="text-center mb-4">
                        <h2 className="fw-bold">Engagement</h2>
                    </div>

                    {/* Card Layout */}
                    <div className="border-0">
                        <div className="py-3 px-md-5 px-3">

                            {/* Render Dangerous HTML from API */}
                            <div
                                dangerouslySetInnerHTML={{ __html: sessionHtml }}
                                className="content-text partner-text-justify fw-bold lh-lg"
                            ></div>

                        </div>
                    </div>
                </> : <p className="text-center">Will Be Added Shortly</p>}
            </div>
    )
}

export default SampleModuleEngagement